import { apiClient } from '../config';
import { snakeCase } from 'change-case';
async function getDataPortalDropDown(
  entity: string,
  page?: number,
  search?: string
) {
  const params = {
    page: page,
    entity: snakeCase(entity),
    searchString: search,
  };
  const res = await apiClient.get(`/admin/chat-dropdown`, {
    params,
  });
  return res.data;
}

export default getDataPortalDropDown;
